import { Component } from "excalibur";

export class ChaseHeroComponent extends Component {
  constructor(public speed: number) {
    super();
  }
}
